import {ChangeDetectionStrategy, Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FormControl, FormGroup} from '@angular/forms';
import {BiolinkEditorService} from '../../biolink-editor.service';

export interface CrupdateWidgetDialogData {
    widgetId?: number;
    config?: object;
}

@Component({
    selector: 'text-widget-modal',
    templateUrl: './text-widget-modal.component.html',
    styleUrls: ['./text-widget-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TextWidgetModalComponent {
    form = new FormGroup({
        title: new FormControl(),
        description: new FormControl(),
    });

    constructor(
        private dialogRef: MatDialogRef<TextWidgetModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: CrupdateWidgetDialogData,
        public editor: BiolinkEditorService,
    ) {
        if (data.config) {
            this.form.patchValue(data.config);
        }
    }

    createOrUpdate() {
        this.editor
            .crupdateWidget(this.data.widgetId, 'text', this.form.value)
            .subscribe(response => {
                this.dialogRef.close(response.widget);
            });
    }

    close() {
        this.dialogRef.close();
    }
}
